import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "top-matter" }
const _hoisted_2 = { class: "name" }

import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import NcActions from '@nextcloud/vue/components/NcActions';
import NcActionButton from '@nextcloud/vue/components/NcActionButton';

import { t } from '@services/l10n';
import { routes } from '@services/router';
import * as strings from '@services/strings';

import BackIcon from 'vue-material-design-icons/ArrowLeft.vue';


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'ClusterTopMatter',
},
  __name: 'ClusterTopMatter',
  setup(__props) {



const route = useRoute();
const router = useRouter();

const viewname = computed((): string => {
  return strings.viewName(route);
});

const name = computed((): string | null => {
  switch (route.name) {
    case routes.Tags.name:
      return t('recognize', route.params.name?.toString());
    default:
      return null;
  }
});

function back() {
  router.go(-1);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (name.value)
      ? (_openBlock(), _createBlock(_unref(NcActions), { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_unref(NcActionButton), {
              "aria-label": _unref(t)('memories', 'Back'),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (back()))
            }, {
              icon: _withCtx(() => [
                _createVNode(BackIcon, { size: 20 })
              ]),
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('memories', 'Back')) + " ", 1)
              ]),
              _: 1
            }, 8, ["aria-label"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("span", _hoisted_2, _toDisplayString(name.value || viewname.value), 1)
  ]))
}
}

})